var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 0.5H2.25C1.78601 0.500463 1.34116 0.684987 1.01307 1.01307C0.684987 1.34116 0.500463 1.78601 0.5 2.25V19.75C0.500463 20.214 0.684987 20.6588 1.01307 20.9869C1.34116 21.315 1.78601 21.4995 2.25 21.5H19.75C20.214 21.4995 20.6588 21.315 20.9869 20.9869C21.315 20.6588 21.4995 20.214 21.5 19.75V2.25C21.4995 1.78601 21.315 1.34116 20.9869 1.01307C20.6588 0.684987 20.214 0.500463 19.75 0.5ZM12.75 2.25V5.75H9.25V2.25H12.75ZM2.25 19.75V2.25H7.5V7.5H14.5V2.25H19.75L19.7509 19.75H2.25Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTour);
export default __webpack_public_path__ + "static/media/tour.6a67a7d40b3348c5cb6d6050118b8748.svg";
export { ForwardRef as ReactComponent };